import { ModalResponse } from '../../enum/ModalResponse';
import React from 'react';
import ReactModal from 'react-modal';

export interface ModalProps {
  isOpen: boolean;
  onClickAction?: (response?: ModalResponse) => void;
  onClose?: (response?: ModalResponse) => void;
  onOpen?: () => void;
  children?: React.ReactNode;
  actions?: React.ReactNode;
}
export default function Modal({ isOpen, onClose, onOpen, children, actions }: ModalProps) {
  return (
    <ReactModal isOpen={isOpen} onAfterOpen={onOpen} onAfterClose={onClose} closeTimeoutMS={250}>
      {children && <div className="modal__content">{children}</div>}
      {actions && <div className="modal__actions">{actions}</div>}
    </ReactModal>
  );
}
